import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createDatasetActions } from './actions';
import { DatasetActions, DatasetState } from './types';

export const useDatasetStore = create<DatasetState & DatasetActions>()(
    immer((set, get, store) => ({
        datasets: [],
        loading: false,
        componentQueryState: {},
        selectedDataset: null,
        loadingDataset: false,
        error: undefined,
        ...createDatasetActions(set, get, store),
    })),
);
